import { HTMLAttributes } from 'react';
import { Label } from '../../../common/Label/Label';
import { SCORM_LABELS } from '../../../../lib/constants/labelKeys';
import { DownloadIcon } from '../../../../lib/icons/DowloadIcon';

const ScormAddItemButton = (props: HTMLAttributes<HTMLButtonElement>) => {
  return (
    <button {...props}>
      <Label name={SCORM_LABELS.ADD} />
      <DownloadIcon />
    </button>
  );
};

export default ScormAddItemButton;
